import React, { useRef, useState} from 'react';

import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    FORM,
    REQUIRED,
    selectOption,
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {showLoader} from "../../../components/loader/loader";
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import {salesPackageService} from "../../../jwt/_services/promotions/salesPackageService";
import SelectGeneric from "../../../components/select/selectGeneric";
import {categoryProductProvider} from "../../../providers/categoryProductProvider";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {TT_HISTORY} from "../../../components/i18n/toolTips";


export default function SalesPackageForm(props) {
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);

    const [categoryProductId, setCategoryProductId] = useState(editMode ? props.item?.categoryProduct?.id : null);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        packageId: Yup.number().required(REQUIRED),
        name: Yup.string().required(REQUIRED),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            uid: savedData?.uid,
            packageId: savedData?.packageId,
            count: savedData?.count,
            name: savedData?.name
        }
    });

    const onSubmit = (data, _) => {
        if (categoryProductId === null) {
            return showToastCustom(error, selectOption);
        }
        setLoading(true);
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                id: savedData?.id,
                categoryProduct: { id : categoryProductId },
            }
        };

        if (!editMode) {
            //Save
            return salesPackageService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            return salesPackageService.updateItem(savedData.id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setCategoryProductId(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    const setForm = () => props.setForm();

    return ( <>
        { loading && showLoader() }
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="id">ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="uid">UID Firebase</Label>
                                <Input type="id" name="uid" id="uid"
                                       disabled
                                       value={editMode ? savedData?.uid : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input type="text" name="name"
                                       placeholder="Ingrese nombre"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="name" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Id de paquete</Label>
                                <Input type="text" name="packageId"
                                       placeholder="Ingrese id de paquete"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.packageId ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="packageId" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Cantidad</Label>
                                <Input type="number" name="count"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Categoria del producto</Label>
                                <SelectGeneric
                                    initialValue={categoryProductId}
                                    setExternalValue={setCategoryProductId}
                                    isDisabled={disableInputs}
                                    provider={categoryProductProvider}
                                    fbDataBaseId={fbDataBaseId}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ savedData }
            />
        }

    </> )
}